<script setup lang="ts">
import { onMounted, onUnmounted, computed } from 'vue';
import { useMapStore } from '@/stores/mapStore.ts';
import PlayerName from '@/components/Objects/PlayerName.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const mapStore = useMapStore();

const compatibilityText = computed(() => {
  const compat = mapStore.playerNameTooltipCompatibility;
  const compatMap: Record<string, string> = {
    'A': 'planets.compatibility.paradise',
    'B': 'planets.compatibility.lush',
    'C': 'planets.compatibility.habitable',
    'D': 'planets.compatibility.incompatible',
    'E': 'planets.compatibility.toxic',
    'F': 'planets.compatibility.frozen',
  };
  return compatMap[compat] ? t(compatMap[compat]) : compat;
});

// Function to update mouse position in the store
function updateMousePosition(event: MouseEvent) {
  mapStore.playerNameTooltipXPos = event.clientX;
  mapStore.playerNameTooltipYPos = event.clientY;
}

onMounted(() => {
  window.addEventListener('mousemove', updateMousePosition);
});

onUnmounted(() => {
  window.removeEventListener('mousemove', updateMousePosition);
});
</script>

<template>
  <div
    v-show="mapStore.playerNameTooltipVisible"
    :style="{
      left: mapStore.playerNameTooltipXPos + 'px',
      top: mapStore.playerNameTooltipYPos - tooltipOffset + 'px',
    }"
    class="tooltip bg-gray-900 z-20 px-1 rounded"
  >
    <span v-if="mapStore.playerNameTooltipOwnerId === 0 && mapStore.playerNameTooltipName">{{ mapStore.playerNameTooltipName }}</span>
    <span v-else-if="mapStore.playerNameTooltipCompatibility"
      :class="{
        'text-green-500': mapStore.playerNameTooltipCompatibility === 'A',
        'text-cyan-500': mapStore.playerNameTooltipCompatibility === 'B',
        'text-subtext': mapStore.playerNameTooltipCompatibility === 'C',
        'text-amber-400': mapStore.playerNameTooltipCompatibility === 'D',
        'text-red-500': mapStore.playerNameTooltipCompatibility === 'E',
        'text-blue-400': mapStore.playerNameTooltipCompatibility === 'F',
      }">{{ compatibilityText }}</span>
    <template v-else>
      <PlayerName :player-id="Number(mapStore.playerNameTooltipOwnerId)" /> <span v-if="mapStore.playerNameTooltipShipCount>0">: {{ mapStore.playerNameTooltipShipCount }}</span>
    </template>
  </div>
</template>

<script lang="ts">
const tooltipOffset = 65; // Adjust this value based on your tooltip's height
</script>

<style scoped lang="scss">
.tooltip {
  position: absolute;
  /* Add any additional styling you need */
}
</style>
